import React from 'react'
import { useTranslation } from 'react-i18next'

import { standardStaticProps } from '~/common/server/standard'
import { signupPath } from '~/common/define/path'
import OpenPageHead from '~/components/header/OpenPageHead'
import { getPublicLayout } from '~/components/layout/layout'
import PageFrame from '~/components/wrapper/screen/PageFrame'
import SignupPage from '~/components/page/signup/SignupPage'

const Page = () => {
  const {t} = useTranslation()
  return (
    <>
      <OpenPageHead title={t('signup:head_title.create')} path={signupPath()} seoOn/>
      <PageFrame>
        <SignupPage/>
      </PageFrame>
    </>
  )
}

Page.getLayout = getPublicLayout

export const getStaticProps = standardStaticProps(['signup', 'org', 'account'])

export default Page